import React from 'react';
import './css/aboutIntro.css';

export default function AboutIntro() {
    return (
        <section className="about-intro">
            <div className="about-intro__lead">
                <h2 className="about-intro__title">Learn more about our mission, values, and who we are.</h2>
            </div>
            <div className="about-intro__grid">
                <section className="about-intro__card">
                    <h3>Our Mission</h3>
                    <p>We are dedicated to providing excellent service and innovative solutions.</p>
                </section>
                <section className="about-intro__card">
                    <h3>Our Team</h3>
                    <p>Our talented team is committed to delivering quality results.</p>
                </section>
            </div>
        </section>
    );
}